export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <circle cx="24" cy="24" r="21" stroke="#D4AF37" strokeWidth="1.5" />
    <circle cx="24" cy="24" r="14.5" stroke="#D4AF37" strokeWidth="0.75" opacity="0.45" />
    <path d="M24 7 L28.5 24 L24 41 L19.5 24 Z" fill="#D4AF37" />
    <path d="M7 24 L24 19.5 L41 24 L24 28.5 Z" fill="#F8F6F0" opacity="0.85" />
    <circle cx="24" cy="24" r="2.4" fill="#070E1A" stroke="#D4AF37" strokeWidth="1.2" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark />
    <span className="flex flex-col leading-none">
      <span className="font-serif text-xl font-semibold tracking-[0.12em] text-ivory">ATLAS</span>
      <span className="font-mono text-[8px] tracking-[0.32em] text-gold uppercase mt-1">
        Property Intelligence
      </span>
    </span>
  </span>
);
